(function(){
  if(window.__lx3d) return; window.__lx3d = 1;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function setHand(el, period, frac){
    if(!el) return;
    if(reduce){ el.style.setProperty('--a', (frac*360).toFixed(2)+'deg'); return; }
    el.style.animation = 'lx3dTurn '+period+'s linear '+(-frac*period).toFixed(2)+'s infinite';
  }
  function clocks(root){
    root.querySelectorAll('.lx3d-watch').forEach(function(w){
      if(w.__c) return; w.__c = 1;
      var d = new Date();
      var s = d.getSeconds() + d.getMilliseconds()/1000, m = d.getMinutes() + s/60, h = (d.getHours()%12) + m/60;
      setHand(w.querySelector('[data-s]'), 60, s/60);
      setHand(w.querySelector('[data-m]'), 3600, m/60);
      setHand(w.querySelector('[data-h]'), 43200, h/12);
    });
  }
  function scenes(root){
    if(!fine || reduce) return;
    root.querySelectorAll('[data-lx3d]').forEach(function(stage){
      if(stage.__s) return; stage.__s = 1;
      var hero = stage.closest('.lx-hero') || document.body;
      var bx = -18, by = 8, tx = bx, ty = by, cx = bx, cy = by, raf = 0;
      function step(){
        cx += (tx-cx)*0.08; cy += (ty-cy)*0.08;
        stage.style.setProperty('--ry', cx.toFixed(2)+'deg');
        stage.style.setProperty('--rx', cy.toFixed(2)+'deg');
        if(Math.abs(tx-cx) > 0.05 || Math.abs(ty-cy) > 0.05){ raf = requestAnimationFrame(step); } else { raf = 0; }
      }
      function kick(){ if(!raf) raf = requestAnimationFrame(step); }
      hero.addEventListener('pointermove', function(e){
        var r = hero.getBoundingClientRect();
        var nx = (e.clientX - r.left)/r.width*2 - 1, ny = (e.clientY - r.top)/r.height*2 - 1;
        tx = nx*28; ty = -ny*16 + 4; kick();
      });
      hero.addEventListener('pointerleave', function(){ tx = bx; ty = by; kick(); });
    });
  }
  var TILT = [['.lx-cat',7],['.lx-card__media',10],['.lx-story__media',5],['.lx-rev',5]];
  function tilts(root){
    if(!fine || reduce) return;
    TILT.forEach(function(t){
      root.querySelectorAll(t[0]).forEach(function(el){
        if(el.__t) return; el.__t = 1;
        el.classList.add('lx-tilt');
        if(getComputedStyle(el).position === 'static') el.style.position = 'relative';
        var g = document.createElement('span'); g.className = 'lx-glare'; el.appendChild(g);
        var max = t[1];
        el.addEventListener('pointerenter', function(){ el.classList.add('is-tilting'); });
        el.addEventListener('pointermove', function(e){
          var r = el.getBoundingClientRect();
          var px = (e.clientX - r.left)/r.width, py = (e.clientY - r.top)/r.height;
          el.style.transform = 'perspective(1000px) rotateX('+((0.5-py)*max*2).toFixed(2)+'deg) rotateY('+((px-0.5)*max*2).toFixed(2)+'deg) scale3d(1.02,1.02,1.02)';
          el.style.setProperty('--gx', (px*100).toFixed(1)+'%');
          el.style.setProperty('--gy', (py*100).toFixed(1)+'%');
        });
        el.addEventListener('pointerleave', function(){ el.classList.remove('is-tilting'); el.style.transform = ''; });
      });
    });
  }
  var REVEAL = '.lx-head, .lx-cat, .lx-card, .lx-story > *, .lx-trust__i, .lx-rev, .lx-faq details, .lx-cta .lx-wrap > *';
  var io = null;
  function reveals(root){
    if(reduce || !('IntersectionObserver' in window)) return;
    if(!io){
      io = new IntersectionObserver(function(entries){
        entries.forEach(function(en){
          if(!en.isIntersecting) return;
          var el = en.target; io.unobserve(el);
          el.classList.add('lx-in');
          var delay = parseFloat(el.style.getPropertyValue('--d')) || 0;
          setTimeout(function(){ el.classList.remove('lx-r','lx-in'); el.style.removeProperty('--d'); }, 1300 + delay*1000);
        });
      }, {threshold: 0.12, rootMargin: '0px 0px -40px 0px'});
    }
    root.querySelectorAll(REVEAL).forEach(function(el){
      if(el.__r) return; el.__r = 1;
      var i = Array.prototype.indexOf.call(el.parentNode.children, el);
      el.style.setProperty('--d', (Math.min(i,6)*0.09).toFixed(2)+'s');
      el.classList.add('lx-r');
      io.observe(el);
    });
  }
  function init(root){ root = root || document; clocks(root); scenes(root); tilts(root); reveals(root); }
  if(document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', function(){ init(); });
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
